import React from 'react';
import { compose } from 'recompose';
import WithDrawer from '../../../Common/Drawer/WithDrawer';
import Header from '../Header';
import { withStyles } from '@material-ui/core';
import Footer from '../Footer';
import { inject, observer } from 'mobx-react';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { AppLoading } from '../../../../../../loaders/loaders';
import { withSnackbar } from 'notistack';
import { getProNumbers } from '../../DriverPopUp/utils';
import ProInfo from './components/ProInfo';
import StopImagesDialog from '../../DriverPopUp/StopImagesDialog';
import { STOP_IMAGES } from '../../DriverPopUp/StopImagesDialog/getBlobImages';
import styles from './style';
import { fetchAndSetStaticData } from '../utils';
import { withAppConfig } from '../../../../../../appConfigContext';

@inject('DispatchStore')
@observer
class ProDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      proDetails: null,
      viewStopImages: null
    };
  }

  componentDidMount() {
    const {
      DispatchStore,
      userData: { userProfile }
    } = this.props;
    fetchAndSetStaticData({ DispatchStore, userProfile }).then(() => {
      this.setState({
        proDetails: this.props.proDetails
      });
    });
  }


  onViewStopImages = () => {
    const { stopData, driverData } = this.state.proDetails ?? {};
    this.setState({
      viewStopImages: {
        terminalCode: this.props.userData.userProfile.terminal.code,
        routeId: driverData.routeId,
        stopId: stopData?.stopId,
        isStopCompleted: stopData.isStopCompleted,
        proNumbers: getProNumbers(stopData.shipments)
      }
    });
  };

  onHideStopImages = () => {
    this.setState({
      viewStopImages: null
    });
  };
  render() {
    const { proData, stopData, driverData } = this.state.proDetails ?? {};
    const deliveryStatusList = this.props.DispatchStore.staticClientData
      ? this.props.DispatchStore.deliveryStatuses
      : [];
    const {
      onClose,
      classes,
      hideViewProImages,
      freightBillDetailsApi,
      freightBillDetailsQueryParams,
      proImageApiName
    } = this.props;
    const viewStopImages = this.state.proDetails
      ? {
          terminalCode: driverData.terminalCode || this.props.userData.userProfile.terminal.code,
          routeId: driverData.routeId,
          stopId: stopData.stopId,
          isStopCompleted: stopData.isStopCompleted,
          proNumbers: getProNumbers(stopData.shipments)
        }
      : null;
    return this.state.proDetails ? (
      <>
        <Header
          onClose={onClose}
          proNumber={proData.proId}
          onViewStopImages={this.onViewStopImages}
          hideViewProImages={hideViewProImages}
        />
        <div id="drawerContent" className={`${classes.contentStyles} customScroll`}>
          <ProInfo
            classes={classes}
            proDetails={this.state.proDetails}
            deliveryStatusList={deliveryStatusList}
            freightBillDetailsApi={freightBillDetailsApi}
            freightBillDetailsQueryParams={freightBillDetailsQueryParams}
            DispatchStore={this.props.DispatchStore}
            enableReturnExceptionReasonLabels={Boolean(
              this.props.configJSON?.enableReturnExceptionReasonLabels
            )}
          />
          {this.state.proDetails && this.state.viewStopImages ? (
            <StopImagesDialog
              showImages={proData.proId || Object.keys(STOP_IMAGES)[0]}
              {...viewStopImages}
              stops={driverData.stops}
              close={this.onHideStopImages}
              apiName={proImageApiName || 'GetImages'}
            />
          ) : null}
        </div>
        <Footer onClose={onClose} />
      </>
    ) : (
      <AppLoading />
    );
  }
}

export default compose(
  withStyles(styles),
  WithDrawer,
  withUserProfile,
  withSnackbar,
  withAppConfig
)(ProDetails);
